import './index.scss'
import {Menu} from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'
import classNames from 'classnames'
import ContentLoader from '../loader'
import {useSelector} from 'react-redux'

const Dropdown = ({children, align = 'end', menuButton, closeMenu, innerRef, loader = false, position = 'absolute', ...props}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('custom-dropdown', {
            dark: isDarkMode
        })}>
            <Menu menuClassName={classNames({
                'align-items-center': loader,
                [props?.className]: !!props?.className
            })} align={align} position={position} offsetY={10}
            closemenu={closeMenu} instanceRef={innerRef} menuButton={menuButton}
            transition onMenuChange={(e) => {
                if (e.open) {
                    !!props?.memberIndex && props?.setOpenMenu({
                        [props.memberIndex]: e.open
                    })
                    !!props?.onMenuChange && props.onMenuChange()
                }
            }} >
                {loader ? <ContentLoader className="unset" height="100" width="100"/> : children}
            </Menu>
        </div>
    )
}

export default Dropdown
